import React, { useContext } from "react";
import { Typography } from "@mui/material";
import { ErrorMessage, Field } from "formik";
import TextError from "../TextError";
import useFormikRadio from "./useFormikRadio";
import FormikControlContext from "../../../Contexts/FormikControlContext";

const FormikRadio = () => {
  const field = useContext(FormikControlContext);
  const { label, name, options, validation, readOnly, hintText } = field;

  const { handleChange, handleBlur } = useFormikRadio();

  return (
    <div className="form-control">
      <div className="d-flex justify-content-between">
        <Typography>
          {label}
          {validation?.required && <span>*</span>}{" "}
        </Typography>
        <div>
          {options.map((option, index) => (
            <div className="form-check form-check-inline" key={index}>
              <Field
                type="radio"
                className="form-check-input"
                id={name}
                name={name}
                value={option.value.toString()}
                placeholder={hintText || label}
                onChange={(e) => handleChange(name, e)}
                onBlur={(e) => handleBlur(name, e)}
                disabled={Boolean(readOnly)}
                required={validation?.required ?? false}
              />
              <label htmlFor={name}>{option.label}</label>
            </div>
          ))}
        </div>
      </div>

      <ErrorMessage name={name} component={TextError} />
    </div>
  );
};

export default FormikRadio;
